import React from "react";
import {
    CardContainer,
    CardGalleryContainer,
    CardTitle,
} from "properties/propertyCard/components/PropertyCardComponents";
import { isLandOrCommercial } from "_common/_utils/propertyUtils";
import { PropertyCardAddress } from "properties/propertyCard/components/PropertyCardAddress";
import { FavoriteCardPrice } from "users/profile/FavoriteCardPrice";
import { userStore } from "users/_stores/userStore";
import { ADMIN_RESOURCE } from "admin/_common/photos/AdminPhotosStore";
import { useTranslation } from "react-i18next";
import { Separator } from "_common/ui/components/Separator";
import { PropertyCardGallery } from "properties/propertyCard/components/PropertyCardGallery";
import { FavoriteCardProps } from "properties/propertyCard/types/favorite-card.type";
import { PropertyFavoriteCardRooms } from "properties/propertyCard/components/favorite/property-favorite-card-rooms";
import { PropertyCardSubTitle } from "properties/propertyCard/components/PropertyCardSubTitle";
import { PropertyCardSurfaces } from "properties/propertyCard/components/PropertyCardSurfaces";
import { PropertyFavoriteCardUnits } from "properties/propertyCard/components/favorite/property-favorite-card-units";

type Props = {
    item: FavoriteCardProps;
};

export default function PropertyFavoriteCardContent({ item }: Props) {
    const { t } = useTranslation();
    const favoritesUnits = userStore.favoritesUnits.filter((unit) => unit.propertyId === item._id);

    return (
        <CardContainer className={"shadow-[0px_0px_5px_0px_#1A3A454D] hover:shadow-[0px_0px_8px_0px_#1A3A454D]"}>
            <CardGalleryContainer>
                <PropertyCardGallery
                    property={{
                        _id: item._id,
                        photos: item.photos,
                        localized: {
                            title: item.title,
                            discountText: item.discountText,
                        },
                        type: item.type,
                        phases: item.inventory?.phases || [],
                        discount: item.discount,
                    }}
                    isFavoriteCard={true}
                />
            </CardGalleryContainer>
            <div className={"mb-2.5"}>
                <div className={"flex justify-between items-center"}>
                    <CardTitle className={"truncate"}>{item.title}</CardTitle>
                    {item.resource === ADMIN_RESOURCE.UNIT && (
                        <CardTitle className={"truncate"}>#{item.unitName}</CardTitle>
                    )}
                </div>
                <CardTitle className={"truncate"}>
                    <PropertyCardSubTitle
                        priceMin={item.price.priceMin}
                        priceInPesosMin={item.price.priceInPesosMin}
                        isInPesosProperty={item.price.isInPesosProperty}
                        isPriceNotDisplayed={item.price.isPriceNotDisplayed}
                    />
                </CardTitle>
            </div>
            <div className={"flex gap-2 mb-2.5 truncate"}>
                {!isLandOrCommercial(item.type) && typeof item?.bedrooms?.min === "number" && (
                    <PropertyFavoriteCardRooms min={item.bedrooms.min} max={item.bedrooms?.max} />
                )}
                {!!item?.squareSurfaceMin && <PropertyCardSurfaces surfaceMin={item.squareSurfaceMin} />}
            </div>
            <div className={"mb-2.5 truncate"}>
                <PropertyCardAddress address={item.address} />
            </div>
            <FavoriteCardPrice
                priceMin={item.price.priceMin}
                priceInPesosMin={item.price.priceInPesosMin}
                isInPesosProperty={item.price.isInPesosProperty}
                isPriceNotDisplayed={item.price.isPriceNotDisplayed}
                resource={item.resource}
            />
            {item.resource === ADMIN_RESOURCE.PROPERTIES && (
                <>
                    <Separator className={"my-2 border-[#e5e7eb]"} />
                    {/*<div className={"text-xs my-2"}>{t("favoritesPage.favoritesUnits")}</div>*/}
                    <div className={"space-y-2 overflow-y-auto h-24"}>
                        {favoritesUnits.map((unit) => {
                            return (
                                <PropertyFavoriteCardUnits
                                    unit={unit}
                                    key={unit._id}
                                    isInPesosProperty={item.price.isInPesosProperty}
                                />
                            );
                        })}
                        {favoritesUnits.filter((unit) => unit.propertyId === item._id).length === 0 && (
                            <div className={"text-sm"}>{t("favoritesPage.noUnits")}</div>
                        )}
                    </div>
                </>
            )}
        </CardContainer>
    );
}
